import { MessagingTemplatesState } from "@idw-types/state/messaging-templates-state";
import { getMessagingTemplatesState } from "@redux/selectors/root-selectors";
import { createSelector } from "reselect";

export const getMessagingTemplatesDataState = createSelector(getMessagingTemplatesState, (state: MessagingTemplatesState) => {
    return {
        isLoadingMessagingTemplates: state.messagingTemplates.isLoading,
        messagingTemplates: state.messagingTemplates.messagingTemplates
    };
});